import React from 'react';

const SkipLinks = () => {
  return (
    <nav>
      <ul>
        <li>
          <a href='#skip-content'>
            {__('Pārlekt uz saturu')}
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default SkipLinks;



// WEBPACK FOOTER //
// ./src/modules/Header/components/SkipLinks/SkipLinks.jsx